export default "__VITE_ASSET__Dwqn5Dsv__"